/**
 * Copies text to clipboard with modern API and fallback for older browsers
 * @param {string} text - Text to copy
 * @returns {Promise<boolean>} - Success status
 */
export function copyToClipboard(text) {
    // Try using the modern Clipboard API first
    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard
            .writeText(text)
            .then(() => true)
            .catch((err) => {
                console.error("Clipboard API failed:", err);
                // Fall back to older method
                return fallbackCopyToClipboard(text);
            });
    } else {
        // Fall back for browsers without Clipboard API support
        return Promise.resolve(fallbackCopyToClipboard(text));
    }
}

/**
 * Fallback method for clipboard copy using document.execCommand
 * @param {string} text - Text to copy
 * @returns {boolean} - Success status
 */
function fallbackCopyToClipboard(text) {
    // Create a temporary textarea element
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Make it invisible but still on the page
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);

    // Select and copy
    textArea.focus();
    textArea.select();

    let successful = false;
    try {
        successful = document.execCommand("copy");
    } catch (err) {
        console.error("Fallback copy failed:", err);
    }

    // Clean up
    document.body.removeChild(textArea);
    return successful;
}
